const EU_COUNTRIES = [
  'se',
  'be',
  'bg',
  'cy',
  'dk',
  'ee',
  'fi',
  'fr',
  'gr',
  'ie',
  'it',
  'lv',
  'lt',
  'lu',
  'mt',
  'nl',
  'pl',
  'pt',
  'ro',
  'sk',
  'si',
  'es',
  'cz',
  'de',
  'hu',
  'at',
  'hr',
];

export function isEU(country_code: string): boolean {
  return EU_COUNTRIES.includes(country_code ? country_code.toLowerCase() : '');
}
export const STATES: { [key: string]: { [key: string]: string } } = {
  us: {
    '': '-',
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    AA: 'Armed Forces America',
    AE: 'Armed Forces Europe',
    AP: 'Armed Forces Pacific',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  },
  // Australia
  au: {
    '': '-',
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia',
  },
  // Mexico
  mx: {
    '': '-',
    AG: 'Aguascalientes',
    BJ: 'Baja California',
    BS: 'Baja California Sur',
    CP: 'Campeche',
    CH: 'Chiapas',
    CI: 'Chihuahua',
    CU: 'Coahuila',
    CL: 'Colima',
    DF: 'Distrito Federal',
    DG: 'Durango',
    GJ: 'Guanajuato',
    GR: 'Guerrero',
    HG: 'Hidalgo',
    JA: 'Jalisco',
    EM: 'Mexico',
    MH: 'Michoacan',
    MR: 'Morelos',
    NA: 'Nayarit',
    NL: 'Nuevo Leon',
    OA: 'Oaxaca',
    PU: 'Puebla',
    QA: 'Queretaro',
    QR: 'Quintana Roo',
    SL: 'San Luis Potosi',
    SI: 'Sinaloa',
    SO: 'Sonora',
    TA: 'Tabasco',
    TM: 'Tamaulipas',
    TL: 'Tlaxcala',
    VL: 'Veracruz',
    YC: 'Yucatan',
    ZT: 'Zacatecas',
  },
  // Canada
  ca: {
    '': '-',
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NT: 'Northwest Territories',
    NS: 'Nova Scotia',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
  },
  // China
  cn: {
    '': '-',
    BJ: 'Běijīng Shì',
    TJ: 'Tiānjīn Shì',
    HE: 'Héběi Shěng',
    SX: 'Shānxī Shěng',
    NM: 'Nèi Měnggǔ Zìzhìqū',
    LN: 'Liáoníng Shěng',
    JL: 'Jílín Shěng',
    HL: 'Hēilóngjiāng Shěng',
    SH: 'Shànghǎi Shì',
    JS: 'Jiāngsū Shěng',
    ZJ: 'Zhèjiāng Shěng',
    AH: 'Ānhuī Shěng',
    FJ: 'Fújiàn Shěng',
    JX: 'Jiāngxī Shěng',
    SD: 'Shāndōng Shěng',
    HA: 'Hénán Shěng',
    HB: 'Húběi Shěng',
    HN: 'Húnán Shěng',
    GD: 'Guǎngdōng Shěng',
    GX: 'Guǎngxī Zhuàngzú Zìzhìqū',
    HI: 'Hǎinán Shěng',
    CQ: 'Chóngqìng Shì',
    SC: 'Sìchuān Shěng',
    GZ: 'Guìzhōu Shěng',
    YN: 'Yúnnán Shěng',
    XZ: 'Xīzàng Zìzhìqū',
    SN: 'Shǎnxī Shěng',
    GS: 'Gānsù Shěng',
    QH: 'Qīnghǎi Shěng',
    NX: 'Níngxià Huízú Zìzhìqū',
    XJ: "Xīnjiāng Wéiwú'ěr Zìzhìqū",
    HK: 'Xiānggǎng Tèbié Xíngzhèngqū',
    MC: 'Àomén Tèbié Xíngzhèngqū',
    TW: 'Táiwān Shěng',
  },
  // Japan
  jp: {
    '': '-',
    Hokkaido: '北海道',
    Aomori: '青森県',
    Iwate: '岩手県',
    Miyagi: '宮城県',
    Akita: '秋田県',
    Yamagata: '山形県',
    Fukushima: '福島県',
    Ibaraki: '茨城県',
    Tochigi: '栃木県',
    Gunma: '群馬県',
    Saitama: '埼玉県',
    Chiba: '千葉県',
    Tokyo: '東京都',
    Kanagawa: '神奈川県',
    Niigata: '新潟県',
    Toyama: '富山県',
    Ishikawa: '石川県',
    Fukui: '福井県',
    Yamanashi: '山梨県',
    Nagano: '長野県',
    Gifu: '岐阜県',
    Shizuoka: '静岡県',
    Aichi: '愛知県',
    Mie: '三重県',
    Shiga: '滋賀県',
    Kyoto: '京都府',
    Osaka: '大阪府',
    Hyogo: '兵庫県',
    Nara: '奈良県',
    Wakayama: '和歌山県',
    Tottori: '鳥取県',
    Shimane: '島根県',
    Okayama: '岡山県',
    Hiroshima: '広島県',
    Yamaguchi: '山口県',
    Tokushima: '徳島県',
    Kagawa: '香川県',
    Ehime: '愛媛県',
    Kochi: '高知県',
    Fukuoka: '福岡県',
    Saga: '佐賀県',
    Nagasaki: '長崎県',
    Kumamoto: '熊本県',
    Oita: '大分県',
    Miyazaki: '宮崎県',
    Kagoshima: '鹿児島県',
    Okinawa: '沖縄県',
  },
};
